export const DEFAULT_LOCALE = "de";
export const COOKIE_GOOGLE_ANALYTICS = "_ga";
export const LOCAL_STORAGE_UTM = "utm";
export const WEBSITE_HOST = "https://justhome.com";

export enum FathomEvent {
  APPLICATION_STARTED = "FUNNEL_First_page_action",
}
